import userScenario from './user';

export default function (server) {
  // Set up user scenario.
  userScenario(server);
}
